import { Directive, ElementRef, HostListener, Input, OnInit } from "@angular/core";

@Directive({
    selector: '[appTankContainerNrDirective]',
    standalone: false
})
export class TankContainerNrDirective {
  private regex = new RegExp(/^((?=.{0,11}$)[aA-zZ]){1,4}((?=.{0,7}$)[0-9]){0,11}$/);
  private letters = new RegExp(/([a-zA-Z]){4}/);
  private digits =  new RegExp(/[0-9]+/);

  private specialKeys = [
    "Backspace",
    "Tab",
    "End",
    "Home",
    "ArrowLeft",
    "ArrowRight",
    "Delete",
  ];

  // TODO: Update regex to remove this special characters
  private invalidKeys = ["`", "^", "_", "]", "[", "\\"];

  constructor(private el: ElementRef) {
  }
  

  @HostListener("keydown", ["$event"])
  onKeyDown(event: KeyboardEvent) {
    // Allow Backspace, tab, end, and home keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }

    if( this.el.nativeElement.selectionStart 
      != this.el.nativeElement.selectionEnd) {
      this.el.nativeElement.value = null;
    } 

    const current: string = this.el.nativeElement.value;
    const position = this.el.nativeElement.selectionStart;
    this.el.nativeElement.setSelectionRange(position, position, "none");

    const next: string =
      current.slice(0, position) + event.key + current.slice(position);

    if (
      (next && !String(next).match(this.regex)) ||
      this.invalidKeys.indexOf(event.key) !== -1 ||
      (String(event.key).match(this.digits) &&  !String(next).match(this.letters))
    ) {
      event.preventDefault();
    }
  }
}
